import React from "react";
import PropTypes from "prop-types";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";

function AssetsHistory(props) {
  const { rowData, onBackClick } = props;

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h5>Assets History</h5>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={onBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Table striped bordered hover>
            <thead>
              <tr>
                <th>SR. No.</th>
                <th>Date</th>
                <th>Plant</th>
                <th>Location</th>
                {/* <th>Address</th> */}
              </tr>
            </thead>
            <tbody>
              {rowData.all_current_assets &&
              rowData.all_current_assets.length > 0 ? (
                rowData.all_current_assets.map((asset, index) => (
                  <tr key={asset.id}>
                    <td>{index + 1}</td>
                    <td>{asset.date}</td>
                    <td>{asset.plant_name}</td>
                    <td>{asset.location_name}</td>
                    {/* <td>{asset.address}</td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No assets history found.
                  </td>
                </tr>
              )}
            </tbody>
          </RB.Table>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default AssetsHistory;
